function startCountdownTimer() {
  setInterval(function () {
    var d = new Date();
    var hours = 23 - d.getHours();
    if (hours < 10) {
      hours = '0' + hours;
    }
    var min = 59 - d.getMinutes();
    if (min < 10) {
      min = '0' + min;
    }
    var sec = 59 - d.getSeconds();
    if (sec < 10) {
      sec = '0' + sec;
    }
    let timeElements = document.getElementsByClassName('aus_timerr');
    for (let i = 0; i < timeElements.length; i++) {
      timeElements[i].innerHTML = `00:${hours}:${min}:${sec}`;
    }
  }, 1000);
}

// Call the function to start the timer
startCountdownTimer();


function reviewsinitializeSwiper() {
  document.querySelectorAll('.u-mySwiper').forEach((swiperEl) => {
    new Swiper(swiperEl, {
      spaceBetween: 30,
      navigation: {
        nextEl: swiperEl.querySelector('.swiper-button-next'),
        prevEl: swiperEl.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        348: {
          centeredSlides: true,
          slidesPerView: 1.2,
          spaceBetween: 10,
          centeredSlidesBounds: true,
        },
        640: {
          slidesPerView: 2.2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
      },
    });
  });
}